var map = {
	"./Hupspot.png": 82107,
	"./Odoo.png": 79149,
	"./Salesforce.png": 42799,
	"./Ziwo.png": 24131,
	"./Zoho.png": 62148,
	"./genesys.png": 18158
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64893;